import { render, staticRenderFns } from "./style-sidebar.vue?vue&type=template&id=0a2bd274&scoped=true&"
import script from "./style-sidebar.vue?vue&type=script&lang=js&"
export * from "./style-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bd274",
  null
  
)

export default component.exports